import { Box } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { FormHandles } from '@unform/core';
import { Form } from '../../../shared/forms';
import { useCallback, useRef } from 'react';
import * as Yup from 'yup';
import { feedback } from '../../../shared/services';
import getValidationErrors from '../../../shared/helpers/getValidationErrors';
import { LayoutRegister } from '../../../shared/layouts';
import { VTextField } from '../../../shared/forms';

const schema = Yup.object().shape({
  email: Yup.string().required('Email é obrigatório').email('Email inválido')
});

interface IProps {
  title: string;
  inviteFn: (email: string) => Promise<unknown>;
  onCloseEdit: () => void;
  buttonLabel?: string;
}

export const InviteEmployee: React.FC<IProps> = ({ title, inviteFn, onCloseEdit, buttonLabel = 'Enviar convite' }) => {
  const formRef = useRef<FormHandles>(null);

  const { mutate: invite, isLoading } = useMutation((email: string) => inviteFn(email), {
    onSuccess: () => {
      feedback('E-mail enviado com sucesso!', 'success');
      onCloseEdit();
    },
    onError: (error: Error) => feedback(String(error), 'error'),
  });

  const handleSubmit = useCallback(async (data: { email: string }) => {
    try {
      formRef.current?.setErrors({});
      await schema.validate({ email: data.email }, { abortEarly: false });
      invite(data.email);
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err as Yup.ValidationError);
        formRef.current?.setErrors(errors);
      }
    }
  }, [invite]);

  return (
    <Form ref={formRef} onSubmit={handleSubmit}>
      <LayoutRegister header={title} isLoading={isLoading} isSubmit saveButtonLabel={buttonLabel}>
        <Box display='flex' flexDirection='column' gap={2}>
          <VTextField name='email' label='Email' required />
        </Box>
      </LayoutRegister>
    </Form>
  );
};
